// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Button, FilterIcon, Flex } from '@iheartjane/reefer';
import type { MouseEvent } from 'react';

import { useKioskSpacing } from '@jane/kiosk/hooks';

export interface FiltersButtonProps {
  hasActiveFilters?: boolean;
  onClick: (e: MouseEvent) => void;
}

const StyledIconButton = styled(Button.Icon)(() => {
  const { isIpad, getKioskSpacing } = useKioskSpacing();
  const buttonDimension = getKioskSpacing(64, 48);

  return {
    borderRadius: isIpad ? 12 : 16,
    height: buttonDimension,
    width: buttonDimension,
  };
});

export const FiltersButton = ({
  hasActiveFilters = false,
  onClick,
}: FiltersButtonProps) => {
  return (
    <Flex alignItems="center" flexDirection="row" flexWrap="wrap">
      <StyledIconButton
        ariaLabel="Click to open product filters"
        icon={<FilterIcon size="lg" />}
        onClick={onClick}
        variant={hasActiveFilters ? 'primary' : 'tertiary'}
      />
    </Flex>
  );
};
